import { Button } from '@progress/kendo-react-buttons'
import { SearchBody } from '../../../components/layouts'
import ConstPeriodSettingSearchCondition from './ConstPeriodSettingSearchCondition'
import ConstPeriodSettingReverse from './ConstPeriodSettingReverse'
import { useAccessibleAuthority, usePageTitle } from '../../../components/hooks'
import { Authority } from '../../../gateway/system/Authority'

export default function ConstPeriodSettingSearch() {
  useAccessibleAuthority(Authority.Builder, Authority.Material, Authority.Branch)
  usePageTitle('工期設定マスタメンテナンス')

  return (
    <SearchBody
      pageable={false}
      leftPane={<ConstPeriodSettingSearchCondition />}
      // rightPane={<ConstPeriodSettingSearchResultList />}
      rightPane={<ConstPeriodSettingReverse />}
      rightPaneButton={
        <>
          <Button onClick={() => ''}>戻る</Button>
          <Button onClick={() => ''} themeColor="primary">
            数値クリア
          </Button>
          <Button onClick={() => ''} themeColor="primary">
            登録/修正
          </Button>
        </>
      }
    />
  )
}
